import { compose, withState, lifecycle, withProps, branch } from 'recompose';
import { always, mergeDeepRight, pipe, prop, isNil, defaultTo, filter, either, is, mapObjIndexed, ifElse, contains, __, find, equals, assoc, of, ap, identity, apply } from 'ramda';
import color from 'color';

var srOnly = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  clipPath: 'inset(50%)',
  border: 0
};

var isInCache = function isInCache(key, values, cache) {
  return pipe(prop(key), contains(__, values))(cache);
};

var addToCache = assoc;

var getKeyPath = function getKeyPath(key, path) {
  return path ? "".concat(path, ".").concat(key) : key;
};

var getSameKeyStyles = function getSameKeyStyles(document, styleObj) {
  var inCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var div,
      cache = inCache;
  return pipe(defaultTo({}), filter(either(is(Array), is(Object))), mapObjIndexed(function (values, key) {
    return ifElse(is(Array), function (values) {
      var keyPath = getKeyPath(key, path);

      if (isInCache(keyPath, values, cache)) {
        return cache[keyPath];
      }

      div = div || document.createElement('div');
      var property = find(function (value) {
        // @ts-ignore
        div.style[key] = value; // @ts-ignore

        if (div.style[key] === value) {
          cache = addToCache(keyPath, value, cache);
          return true;
        }
      }, values);
      return property;
    }, function (values) {
      var keyPath = getKeyPath(key, path);
      var result = getSameKeyStyles(document, values, cache, keyPath);
      cache = result.cache;
      return result.resolvedStyles;
    })(values);
  }), function (resolvedStyles) {
    return {
      resolvedStyles: resolvedStyles,
      cache: cache
    };
  })(styleObj);
};

var resolveStyles = function resolveStyles(props) {
  var _getSameKeyStyles = getSameKeyStyles(document, props.styles, props.resolvedStylesCache),
      resolvedStyles = _getSameKeyStyles.resolvedStyles,
      cache = _getSameKeyStyles.cache;

  if (equals(resolvedStyles, props.resolvedStyles) === false) {
    props.setResolvedStyles(resolvedStyles);
    props.setResolvedStylesCache(cache);
  }
};

var sameKeyStyles = function sameKeyStyles() {
  return compose(withState('resolvedStyles', 'setResolvedStyles', null), withState('resolvedStylesCache', 'setResolvedStylesCache', always({})), lifecycle({
    componentWillMount: function componentWillMount() {
      resolveStyles(this.props);
    },
    componentWillUpdate: function componentWillUpdate() {
      resolveStyles(this.props);
    }
  }), withProps(function (ownerProps) {
    return {
      styles: mergeDeepRight(ownerProps.styles || {}, ownerProps.resolvedStyles || {})
    };
  }), branch(pipe(prop('resolvedStyles'), isNil), always(always(null))));
};

var withStyles = function withStyles(stylesheet) {
  return withProps(function (props) {
    return {
      styles: stylesheet(props)
    };
  });
};

var withStyles$1 = function withStyles(stylesheet) {
  return function (props) {
    return Object.assign({}, props, {
      styles: stylesheet(props)
    });
  };
};

var getStyles = function getStyles(stylesheet, stylesheetToStyles, props) {
  var pipeStyles = pipe(of, ap([stylesheet, identity]), apply(stylesheetToStyles));
  return pipeStyles(props);
};

/* eslint-disable max-len */
var modifier = function modifier(namespace, value) {
  return "".concat(namespace, "-").concat(value);
};

var opacify = function opacify(clr, opacity) {
  return color(clr).alpha(opacity).string();
};

function percentage(value) {
  return "".concat(value, "%");
}

export { srOnly, sameKeyStyles, withStyles, withStyles$1 as withStylesHook, getStyles, modifier, opacify, percentage };
